/* Single – Sticky Add To Cart bar */
export function mount() {
  const $ = window.jQuery;
  const bar = document.getElementById('wk-sticky-atc');
  if (!bar) return;

  // guard tegen dubbel binden
  if (bar.dataset.wkBound === '1') return;
  bar.dataset.wkBound = '1';

  const btn        = bar.querySelector('[data-wk-satc-submit]');
  const qtyIn      = bar.querySelector('.wk-satc-qty-input');
  const priceOut   = bar.querySelector('[data-wk-satc-price]');
  const variantOut = bar.querySelector('[data-wk-satc-variant]');

  // HOOFDformulier vinden
  const form =
    document.querySelector('.single-product form.variations_form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.cart[data-wc-main="1"]') ||
    document.querySelector('.single-product form.variations_form.cart') ||
    document.querySelector('.single-product form.cart');
  if (!form) return;

  // Bar tonen wanneer hoofdformulier uit beeld is
  function setBarVisible(show){
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.classList.toggle('is-visible', show);
  }
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => setBarVisible(!en.isIntersecting));
    }, {rootMargin: '0px 0px -80% 0px', threshold: 0});
    io.observe(form);
  } else {
    const onScroll = () => {
      const rect = form.getBoundingClientRect();
      const show = rect.bottom < (window.innerHeight * 0.2) || rect.top < -40;
      setBarVisible(show);
    };
    document.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  // Qty sync (2 kanten)
  const mainQty = form.querySelector('input.qty');
  if (mainQty && qtyIn) {
    qtyIn.value = mainQty.value || '1';
    qtyIn.addEventListener('input', () => {
      const v = Math.max(1, parseInt(qtyIn.value || '1', 10));
      qtyIn.value = String(v);
      mainQty.value = String(v);
      mainQty.dispatchEvent(new Event('change',{bubbles:true}));
    });
    mainQty.addEventListener('input', () => { qtyIn.value = mainQty.value || '1'; });
    bar.querySelectorAll('.wk-satc-qty').forEach(b => {
      b.addEventListener('click', () => {
        const delta = b.getAttribute('data-act') === '+' ? 1 : -1;
        const v = Math.max(1, parseInt(qtyIn.value || '1', 10) + delta);
        qtyIn.value = String(v);
        qtyIn.dispatchEvent(new Event('input', {bubbles:true}));
      });
    });
  }

  // Submit: submit hoofdformulier (met variatie-check)
  if (btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isVariable = form.classList.contains('variations_form');
      const varInput = form.querySelector('input.variation_id');
      if (isVariable && (!varInput || !parseInt(varInput.value || '0', 10))) {
        form.scrollIntoView({behavior:'smooth', block:'center'});
        if ($) $(form).trigger('check_variations');
        return;
      }
      if ($) { $(form).trigger('submit'); }
      else { form.requestSubmit ? form.requestSubmit() : form.submit(); }
    });
  }

  // Prijs & variantnaam live updaten — ALLEEN main prijscontainer
  const total = (() => {
    const inScope =
      form.closest('.single-product')?.querySelector('.wc-price-total[data-scope="main"] [data-pt-amount]') ||
      document.querySelector('.wc-price-total[data-scope="main"] [data-pt-amount]') ||
      form.closest('.single-product')?.querySelector('.wc-price-total [data-pt-amount]') ||
      document.querySelector('.single-product .wc-price-total [data-pt-amount]');
    return inScope || null;
  })();

  if (total && priceOut) {
    const mo = new MutationObserver(() => { priceOut.innerHTML = total.innerHTML; });
    mo.observe(total, {childList:true, subtree:true, characterData:true});
    priceOut.innerHTML = total.innerHTML;
  }

  if ($) {
    const $form = $(form);

    $form.on('found_variation', function(_e, variation){
      if (priceOut && variation && variation.price_html) priceOut.innerHTML = variation.price_html;
      if (variantOut) {
        const label = buildVariantLabel(this);
        variantOut.textContent = label || '';
        variantOut.hidden = !label;
      }
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.getAttribute('data-ready') || 'In winkelwagen';
      }
    });

    $form.on('reset_data hide_variation', function(){
      if (variantOut) variantOut.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Selecteer opties';
      }
    });
  }

  function buildVariantLabel(formEl){
    const parts = [];
    formEl.querySelectorAll('.variations select[name^="attribute_"]').forEach(sel => {
      const tax = sel.getAttribute('name').replace(/^attribute_/, '');
      const nice = tax.replace(/^pa_/, '').replace(/_/g,' ');
      const opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) parts.push(cap(nice)+': '+opt.text);
    });
    return parts.join(' · ');
  }
  function cap(s){ return s ? s.charAt(0).toUpperCase()+s.slice(1) : s; }
}
